import { Injectable } from '@angular/core';

import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';
import { MessengerService } from '../messenger/messenger.service';

@Injectable()
export class ApiKeyService extends RestfulService<Models.CodeSnippet> {

  constructor(private restService: RestService, private ms: MessengerService) {
    super(Models.CodeSnippet);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('credentials');
  }

  public find(params: any): Promise<any> {
    params['type'] = 'api_key';
    return this.ms.find('credentials', params);
  }

  public create(data: any): Promise<any> {
    data['type'] = 'api_key';
    return this.ms.create('credentials', data);
  }

}
